import { useEffect, useState } from 'react';
import MonthNavigator from '../components/calendar/MonthNavigator.jsx';
import { PageNavigator } from './PageNavigator.jsx';
const CreateElements = ({ apiFetcher, currentSection, currentData, head, sortKeys, month, year, prevMonth, nextMonth, page, setPage, totalPages, setTotalPages }) => {
  const [tableData, setTableData] = useState([]);
  const [sortOptions, setSortOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValues, setInputValues] = useState({});

  const monthNames = [
    'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
    'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień',
  ];
  useEffect(() => {
    if (JSON.stringify(tableData) !== JSON.stringify(currentData)) {
        setTableData(currentData);
        const newInputValues = {};
        currentData.forEach(item => {
            if (currentSection === 'waiting-points') {
                newInputValues[item._id] = item.waitingForPoints || 0;
            }
        });
        setInputValues(newInputValues);
    }
    updateSortOptions();
}, [currentData, currentSection]);
const handleInputChange = (id, value) => {
  setInputValues(prev => ({
      ...prev,
      [id]: value >= 0 ? value : 0
  }));
};

useEffect(() => {
    setPage(1);
},[currentSection])
const updateSortOptions = () => {
  const keys = sortKeys[currentSection] || [];
  const heads = {
      'waiting-points': ['Imię', 'Nazwisko', 'ID', 'Oczekujące punkty', 'Dodaj punkty', 'Rezygnacja'],
      'users': ['ID', 'Imię', 'Nazwisko', 'Kod polecenia', 'Punkty'],
      'events': ['Imię i nazwisko', 'ID użytkownika', 'ID rezerwacji', 'Miejscowość', 'Data', 'Odwołaj'],
      'archive-events': ['Imię i nazwisko', 'ID użytkownika', 'ID rezerwacji', 'Miejscowość', 'Data', 'Usuń'],
      'unrealized-archive': ['Imię i nazwisko', 'ID użytkownika', 'ID rezerwacji', 'Miejscowość', 'Data', 'Przywróć'],
      'administrators': ['Imię', 'Nazwisko', 'Nazwa użytkownika', 'Usuń konto'],
  };
  const headArray = heads[currentSection] || [];

  const keyToHeadMap = {
      'name': 'Imię',
      'surname': 'Nazwisko',
      'telephoneNumber': 'Numer telefonu',
      'referralCode': `Kod polecenia`,
      'points': 'Punkty',
      'waitingForPoints': 'Oczekujące punkty',
      'location': 'Miejscowość',
      'date': 'Data',
      'username': 'Nazwa użytkownika',
  };

  const options = keys
      .filter(key => key !== '_id')
      .map((key) => {
          const head = keyToHeadMap[key] || key; 
          const isNumeric = key === 'points' || key === 'waitingForPoints';
          return [
              { value: `${key}-asc`, text: `${head} (${isNumeric ? 'Rosnąco' : 'A-Z'})` },
              { value: `${key}-desc`, text: `${head} (${isNumeric ? 'Malejąco' : 'Z-A'})` },
          ];
      })
      .flat();
  setSortOptions(options);
};

const handleSort = (e) => {
    const [sortBy, order] = e.target.value.split('-');
    const sortedData = sortData([...tableData], sortBy, order);
    setTableData(sortedData);
};

const sortData = (dataArray, sortBy, order) => {
    return dataArray.sort((a, b) => {
        let valueA, valueB;
        if (currentSection === 'waiting-points') {
            valueA = a[sortBy] ?? '';
            valueB = b[sortBy] ?? '';
            if (sortBy === 'waitingForPoints') {
                valueA = Number(valueA) || 0;
                valueB = Number(valueB) || 0;
                return order === 'asc' ? valueA - valueB : valueB - valueA;
            }
        } else if (currentSection === 'users') {
            valueA = a[sortBy] ?? '';
            valueB = b[sortBy] ?? '';
            if (sortBy === 'points') {
                valueA = Number(valueA) || 0;
                valueB = Number(valueB) || 0;
                return order === 'asc' ? valueA - valueB : valueB - valueA;
            }
        } else if (['events', 'archive-events', 'unrealized-archive'].includes(currentSection)) {
            const parsedA = makeEventObject(a) || {};
            const parsedB = makeEventObject(b) || {};
            valueA = parsedA[sortBy] ?? '';
            valueB = parsedB[sortBy] ?? '';
            if (sortBy === 'date') {
                valueA = new Date(a.start?.dateTime || 'Invalid Date');
                valueB = new Date(b.start?.dateTime || 'Invalid Date');
                return order === 'asc' ? valueA - valueB : valueB - valueA;
            }
        } else if (currentSection === 'administrators') {
            valueA = a[sortBy] ?? '';
            valueB = b[sortBy] ?? '';
        }
        return order === 'asc' ? String(valueA).localeCompare(String(valueB)) : String(valueB).localeCompare(String(valueA));
    });
};

  const makeEventObject = (event) => {
    const description = event.description || '';
    const regex = /Imię i nazwisko klienta:\s*(.+?)\s*Numer telefonu:\s*(\d+)\s*E-mail:\s*([\w.-]+@[\w.-]+\.\w+|Nie podano)/;
    const match = description.match(regex);
    if (match) {
      const name = match[1].trim();
      const phone = match[2].trim();
      const startTime = new Date(event.start?.dateTime || 'Invalid Date');
      const endTime = new Date(event.end?.dateTime || 'Invalid Date');
      const location = event.location?.replace(/\([^)]*\)/,``);
      const date = `${startTime.getDate()}.${startTime.toLocaleString('default', { month: 'long' })} ${startTime.getHours().toString().padStart(2, '0')}:${startTime.getMinutes().toString().padStart(2, '0')} - ${endTime.getHours().toString().padStart(2, '0')}:${endTime.getMinutes().toString().padStart(2, '0')}`;
      const userId = event.extendedProperties?.private?.userId || 'Brak';
      const eventId = event.id || 'Brak';
      return { name, phone, userId, eventId, location, date };
    }
    return { name: 'Nieznany', phone: 'Brak', userId: 'Brak', eventId: event.id || 'Brak', location: 'Nie podano', date: 'Brak daty' };
  };

  const handleButtonClick = async (e, action = 'confirm') => {
    if (isLoading) return;
    setIsLoading(true);
    const button = e.target;
    const type = button.dataset.type;
    const id = button.dataset.id;
    const eventId = button.dataset.eventId;
    const points = button.dataset.points || button.value || 0;

    try {
      let response;
      if (type === 'waiting-points') {
        if (action === 'confirm') {
          response = await apiFetcher.addPoints(id, Number(points));
          if (response) {
            setTableData(prevData => prevData.filter(item => item._id !== id));
          } else {
            alert('Błąd podczas dodawania punktów!');
          }
        } else if (action === 'resign') {
          const eventIdResign = await apiFetcher.getEventId(id);
          if (eventIdResign) {
            response = await apiFetcher.markAs('unrealized', eventIdResign);
            if (response) {
              setTableData(prevData => prevData.filter(item => item._id !== id));
            } else {
              alert('Błąd podczas rezygnacji!');
            }
          }else {
            alert(
              `Nie znaleziono wydarzenia w kalendarzu dla tego użytkownika`)
          }
        }
      } else if (type === 'administrators') {
        if (tableData.length <= 1) {
          alert('Nie można usunąć ostatniego administratora!');
          setIsLoading(false);
          return;
        }
        response = await apiFetcher.removeAdmin(id);
        if (response) {
          setTableData(prevData => prevData.filter(item => item._id !== id));
        } else {
          alert('Błąd podczas usuwania administratora!');
        }
      } else if (type === 'events' && action === 'unrealize') {
        response = await apiFetcher.markAs('unrealized', eventId);
        if (response) {
          setTableData(prevData => prevData.filter(item => item.id !== eventId));
        } else {
          alert('Błąd podczas oznaczania jako niezrealizowane!');
        }
      } else if (type === 'unrealized-archive' && action === 'backUp') {
        response = await apiFetcher.markAs('backUp', eventId);
        console.log(response);
        if (response) {
          setTableData(prevData => prevData.filter(item => item.id !== eventId));
        } else {
          alert('Błąd podczas przywracania!');
        }
      } else if (type === 'archive-events' && action === 'delete') {
        response = await apiFetcher.markAs('delete', eventId);

        if (response) {
          setTableData(prevData => prevData.filter(item => item.id !== eventId));
        } else {
          alert('Błąd podczas usuwania!');
        }
      }
    } catch (error) {
      throw error;
      alert('Wystąpił błąd podczas akcji!');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>

      <select id="sort-options" onChange={handleSort} disabled={isLoading}>
        <option disabled value="">Wybierz sortowanie</option>
        {sortOptions.map((sortOption) => (
          
          <option key={sortOption.value} value={sortOption.value}>
            {sortOption.text}
          </option>
        ))}
      </select>
      {currentSection === `events` || currentSection === `archive-events` || currentSection === `unrealized-archive` ?
      <MonthNavigator
      month={monthNames[month]}
      year={year}
      onPrev={prevMonth}
      onNext={nextMonth}
      ></MonthNavigator> :null
      }

      <table id="main-table">
        <thead>
          <tr>
            {head.map((title, index) => (
              <th key={index}>{title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => {
            let rowData;
            if (currentSection === 'waiting-points') {
              rowData = [item.name, item.surname, item._id, item.waitingForPoints];
              return (
                <tr key={index}>
                  {rowData.map((cell, i) => (
                    i === 3 ? (
                      
                      <td key={i}>
                        <input min={0} type="number" onChange={(e) => handleInputChange(item._id, e.target.value)} value={inputValues[item._id] ?? (cell || 0)} />
                      </td>
                    ) : (
                      <td key={i}>{cell}</td>
                    )
                  ))}
                  <td>
                    <button
                      data-type="waiting-points"
                      data-id={item._id}
                      className="waiting-points"
                      value={item.waitingForPoints || 0}
                      onClick={(e) => {
                        const input = e.target.closest('tr').querySelector('input[type="number"]');
                        const points = input.value !== '' ? input.value : e.target.value;
                        e.target.dataset.points = points;
                        handleButtonClick(e);
                      }}
                      disabled={isLoading}
                    >
                      Potwierdź
                    </button>
                  </td>
                  <td>
                    <button
                      data-type="waiting-points"
                      data-id={item._id}
                      className="waiting-points"
                      onClick={(e) => handleButtonClick(e, 'resign')}
                      disabled={isLoading}
                    >
                      Rezygnacja klienta
                    </button>
                  </td>
                </tr>
              );
            } else if (currentSection === 'users') {
              rowData = [item._id, item.name, item.surname, item.referralCode, item.points];
            } else if (['events', 'archive-events', 'unrealized-archive'].includes(currentSection)) {
              const data = makeEventObject(item);
              rowData = [data.name, data.userId, data.eventId, data.location, data.date];
            } else if (currentSection === 'administrators') {
              rowData = [item.name, item.surname, item.username];
            }
            if (!rowData) return null;
            return (
              <tr key={index}>
                {rowData.map((cell, i) => (
                  <td key={i}>{cell}</td>
                ))}
                {currentSection !== 'users' && (
                  <td>
                    <button
                      data-type={currentSection}
                      data-id={item._id}
                      data-event-id={rowData[2]}
                      className={currentSection}
                      onClick={(e) =>
                        handleButtonClick(
                          e,
                          currentSection === 'events'
                            ? 'unrealize'
                            : currentSection === 'archive-events'
                            ? 'delete'
                            : currentSection === 'unrealized-archive'
                            ? 'backUp'
                            : 'confirm'
                        )
                      }
                      disabled={isLoading}
                    >
                      {currentSection === 'events'
                        ? 'Odwołaj rezerwację'
                        : currentSection === 'archive-events'
                        ? 'Usuń'
                        : currentSection === 'unrealized-archive'
                        ? 'Przywróć'
                        : 'Usuń konto'}
                    </button>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {currentSection === `users` || currentSection === `administrators` ?
      <PageNavigator 
      page={page}
      setPage={setPage}
      totalPages={totalPages}>
      </PageNavigator> : null}
    </>
  );
};

export default CreateElements;